<template>
  <div id="app mt24">
    <md-app
      md-mode="fixed"
      :md-scrollbar="true"
      style="min-height:100vh"
    >
      <md-app-toolbar
        style="-webkit-app-region: drag"
        class="md-dense fixed-toolbar md-primary md-elevation-0"
        md-elevation="0"
        v-if="drawer"
      >
        <div
          class="md-subheading"
          style="flex: 1"
        >Fundación Cima Chih</div>
        <MenuList
          @close="_menu"
          @doSync="shouldShowDialog"
        />
      </md-app-toolbar>
      <md-app-content class="md-transparent">
        <vue-page-transition name="fade">
          <router-view
            @msg="notificacion"
            @tipo="tipear"
            @visible="mostrarDrawerToolbar"
            @classes="classes"
            @breadcrumbs="breadcrumbs"
            :class="view_class"
            @escuela="_doNombreEscuela"
            @doSync="shouldShowDialog"
          />
        </vue-page-transition>
      </md-app-content>
    </md-app>
    <md-snackbar
      md-position="center"
      :md-duration="4000"
      :md-active.sync="sb_show"
      md-persistent
    >
      <span>{{sb_msg}}</span>
    </md-snackbar>
    <md-dialog
      :md-active.sync="showDialogSync"
      :md-close-on-esc="false"
      :md-click-outside-to-close="false"
    >
      <md-dialog-title class="text-center">
        Sincronizando
      </md-dialog-title>
      <md-dialog-content class="text-center">
        <md-progress-spinner
          :md-diameter="100"
          :md-stroke="10"
          md-mode="indeterminate"
        />
        <p>Espere un momento en lo que se termina la sincronización.<br>Este proceso puede tomar algunos minutos.</p>
      </md-dialog-content>
    </md-dialog>
    <Respaldo />
  </div>
</template>
<script>
import MenuList from "@/components/menu/MenuList";
import Respaldo from "@/components/Respaldo";
export default {
  name: "App",
  components: { MenuList, Respaldo },
  methods: {
    shouldShowDialog(a) {
      this.showDialogSync = a === "false" ? false : true;
    },
    notificacion(a) {
      this.sb_show = true;
      this.sb_msg = a;
    },
    mostrarDrawerToolbar(a) {
      this.drawer = a;
    },
    breadcrumbs(a) {
      this.bc = a;
    },
    classes(a) {
      this.view_class = a;
    },
    tipear(a) {
      this.tipo =
        this.$session.exists() && this.$session.get("tipo")
          ? this.$session.get("tipo")
          : a;
    },
    _menu(a) {
      this.menu = false;
    },
    _doNombreEscuela() {
      if (this.$session.has("nombre_escuela")) {
        this.nombre_escuela = ", " + this.$session.get("nombre_escuela");
      } else {
        this.nombre_escuela = "";
      }
    }
  },
  data() {
    return {
      sb_show: false,
      sb_msg: null,
      menu: false,
      drawer: false,
      bc: null,
      view_class: null,
      tipo: null,
      nombre_escuela: "",
      showDialogSync: false
    };
  },
  created() {
    this.$headers.headers.Token =
      this.$session.exists() && this.$session.get("token")
        ? this.$session.get("token")
        : null;
    this.tipear();
    this.$material.locale.days = [
      "Domingo",
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado"
    ];
    this.$material.locale.shortDays = [
      "Dom",
      "Lun",
      "Mar",
      "Mié",
      "Jue",
      "Vie",
      "Sáb"
    ];
    this.$material.locale.shorterDays = ["D", "L", "M", "M", "J", "V", "S"];
    this.$material.locale.months = [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre"
    ];
    this.$material.locale.shortMonths = [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic"
    ];
    this.$material.locale.shorterMonths = [
      "E",
      "F",
      "M",
      "A",
      "M",
      "Jn",
      "Jl",
      "A",
      "S",
      "O",
      "N",
      "D"
    ];
    this._doNombreEscuela();
  },
  watch: {
    sb_show(a) {
      this.tipear();
    },
    drawer(a) {
      this.tipear();
    },
    bc(a) {
      this.tipear();
    },
    view_class(a) {
      this.tipear();
    },
    $route(to, from) {
      this._doNombreEscuela();
    }
  },
  computed: {
    networkStatus() {
      let a = this.isOnline ? true : false;
      return a;
    }
  }
};
</script>
<style lang="scss">
@import "assets/styles/main";
</style>